import { ICategory, IContacts, IMenuItemResponce, IMenuListItem } from "./responseTypes";
import { Template } from "../Context/ThemeContext";
import { VisitorPageContents } from "../Pages/Visitor/Menu/visitorPage";
import { ReactNode } from "react";

export enum ButtonTypes {
  Primery = "primery-button",
  Secondary = "secndary-button",
  ButtonWithIcon = "Button_with_left_icon",
  Disabled = "disabled_button",
  WithoutBg = "Without_background",
  Success = "Success"
};

interface INavItem {
  title: string,
  href: string,
  icon: string,
};

export type NavItem = INavItem[];

export enum HomeHeaderNavs {
  Home = "home",
  Business = "business",
}

interface IHomeHeaderNav {
  title: string,
  id: HomeHeaderNavs,
  icon: string
};

export type IHomeHeaderNavItems = IHomeHeaderNav[];

export interface IMainCard {
  title: string,
  image: string
};

export enum SignUpScreens {
  SignUp = "SignUp",
  Verify = "Verification"
};

export enum DrawerOpenSides {
  Left = 'left',
  Right = 'right',
  Top = 'top',
  Bottom = 'bottom'
};

interface IUserDrawerItem {
  title: string,
  icon: any,
  onClick: () => void
};

export interface ILanguages {
  id: number;
  icon: string;
  code: string;
};

export type IUserDrawerList = IUserDrawerItem[];

export interface IVisitorNavItem {
  id: VisitorPageContents,
  title: string,
  onClick: () => void,
  icon?: ReactNode,
}

export interface IBusinessTypesContent {
  title: string,
  icon: string,
  value: BusinessTypes
};

export interface IAutocompleteItem {
  id: string | number,
  title: string,
  icon?: string
};

export type IAutocompleteData = IAutocompleteItem[];

export enum ArrowButtonSides {
  Left = 'left',
  Right = 'right',
};

export enum CustomerCount {
  SMALL = 'small',
  MEDIUM = 'medium',
  BIG = 'big',
  LARGE = 'large'
};

export enum WeekDays {
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
  SUNDAY = 7
}

export enum BusinessTypes {
  RESTAURANT = 'restaurant',
  CAFE = 'cafe',
  HOTEL = 'hotel',
  PIZZERIA = 'pizzeria',
  FAST_FOOD = 'fast_food',
  COFFEE_SHOP = 'coffee_shop',
  SHOP = 'shop'
}

export enum ImageTypes {
  LOGO = 'logo',
  CATEGORY = 'category',
  GALLERY = 'gallery'
}

export interface IBusinessUITemplate {
  id: number,
  name: string,
  screenShot: string
}

export enum MyBusinessContentItems {
  MY_MENU = 'myMenu',
  QR = 'qr',
  FINANCE = 'finance',
  STAFF = 'staff',
  PROFILE = 'profile',
  SERVICES = 'services',
  ORDERS = 'orders'
};

export enum MenuItemTypes {
  DRINK = 'drink',
  FOOD = 'food'
};

export interface IMyBusinessPageNav {
  title: string,
  id: MyBusinessContentItems,
  icon: string
};

export enum MyMenuContentTypes {
  MY_MENU = 'my_menu',
  EDIT_Menu = 'edit_menu',
  STYLING = 'styling',
  PREVIEW = 'preview'
};

export enum MenuListContentTypes {
  CATEGORIES = 'categories',
  ITEMS = 'items'
}

export enum MenuCategoryTypes {
  FOOD = 'food',
  DRINK = 'drink',
  DESSERT = 'dessert',
  OTHER = 'other'
}

export enum SimpleCategoryItemTypes {
  ITEM = 'item',
  BUTTON = 'button'
}

export enum CreateFormTypes {
  CREATE = "create",
  SAVE = "save"
}

export interface IImagePresetTypes {
  id: number,
  label: string,
  sizes: string,
  height: number,
  width: number,
}

export enum MeasureTypes {
  BIG = 'big',
  NORMAL = 'normal',
  SMALL = 'small',
  BOTTLE = 'bottle',
  GRAM = 'gram',
  KILOGRAM = 'kilogram',
  MILLILITER = 'milliliter',
  LITER = 'liter',
  PIECE = 'piece',
  UNIT = 'unit',
  PORTION = 'portion',
  CUP = 'cup',
  OUNCE = 'ounce',
  POUND = 'pound',
  CENTIMETRE = 'centimetre'
}

export enum TimeUnitTypes {
  MINUTE = 'minute',
  HOUR = 'hour'
}

export enum MenuListTypes {
  EDIT = 'edit',
  VIEW = 'view'
}

export enum CatygoryActionTypes {
  EDIT = 'edit',
  ADD = 'add',
  DELETE = 'delete',
  DRAG = 'drag',
  OPEN = 'open'
}

export enum MenuItemActionTypes {
  EDIT = 'edit',
  COPY = 'copy',
  DELETE = 'delete',
  DRAG = 'drag',
  OPEN = 'open',
  VIEW = 'view'
}

export interface ICategoryAction {
  type: CatygoryActionTypes
  icon: string,
  onClick: (data: IMenuListItem, title: string) => void
}


export interface IMenuItemActions {
  type: MenuItemActionTypes,
  icon: string,
  onClick: (categoryId: number, data: IMenuItemResponce, title: string) => void
}

export interface IMenuViewAction {
  title: string,
  icon: string,
  id: MyMenuContentTypes,
}

export interface IBusinessprofileAction {
  title: string,
  icon: string,
  id: BusinessProfileActionTypes
}

export interface IOrdersPageAction {
  title: string,
  icon: string,
  id: OrdersPageActionTypes
}

export enum BusinessServices {
  MY_SERVICES = 'myServices'
}

export interface IBusinessServicesNavs {
  title: string,
  icon: string,
  id: BusinessServices
}

export enum BusinessProfileActionTypes {
  MAIN = 'main',
  GALLERY = 'galery',
  CONTACT = 'contact',
  PREVIEW = 'preview'
}

export enum OrdersPageActionTypes {
  MY_ORDERS = 'my_orders',
  HISTORY = 'history'
}


export enum DrawerItemTypes {
  ACCORDEON = 'accordeon',
  ITEM = 'item'
}

export enum MenuItemOpionFormTypes {
  CREATE = 'create',
  EDIT = 'edit'
}

export interface ICategoryItem {
  title: string,
  data: IMenuListItem
}

export interface IMenuItem {
  name_en: string,
  name_ru: string,
  name_hy: string,
  description_en: string,
  description_ru: string,
  description_hy: string,
  image: string,
  options: any[],
  active_optionID: string,
  category_id: string,
}

export interface IMenu {

}

export interface ICartCategory {
  id: number,
  name_en: string,
  name_ru: string,
  name_hy: string
}

export interface ICartItem {
  category: ICartCategory,
  id: number,
  name_en: string,
  name_ru: string,
  name_hy: string,
  image: string,
  cooking_time: string,
  cooking_time_unit: TimeUnitTypes,
  option: ICartOption[],
  note?: string,

}

export interface ICartOption {
  option_id: number,
  measure_type: MeasureTypes,
  measure_value?: string,
  price: string,
  package_cost?: string,
  count: number
}

export enum ItemCounterTypes {
  CART = 'cart',
  MAIN_CART = 'mainCart'
}

export enum CurrencyTypes {
  AMD = 'amd',
  USD = 'usd',
  RUB = 'rub'
};

export interface IUiTemplate {
  id: Template,
  title: string,
  description: string,
  lightImg: string,
  darkImg: string,
  leftIcon: string,
  rightIcon: string
};

export enum StaffScreenTypes {
  LIST = 'list',
  EMPLOYE = 'employe'
};

export interface IProfilecontactItem {
  id: keyof IContacts,
  icon: string,
}

export enum ContactLinkTypes {
  FACEBOOK = "facebook",
  INSTAGRAM = "instagram",
  VIBER = "viber",
  WHATSAPP = "whatsapp",
  TELEGRAM = "telegram",
  TWITTER = "twitter"
}

export enum OrderTypes {
  DELIVERY = 'delivery',
  PREORDER = 'pre_order',
  RESERVE = 'reserve',
  DINE_IN = 'dine_in'
}

export interface IDeliveryOrderData {
  cart: ICartItem[],
  delivery_cost: number,
  packageFee: number,
  total_cost: number,
}

export interface IPreOrderData {
  cart: ICartItem[],
  packageFee: number,
  total_cost: number,
}

export interface IDineInOrderData {
  cart: ICartItem[],
  service_fee?: number,
  total_cost: number,
  location_type?: HorecaLocationType,
  location_number?: number,
}

export interface IDineInLocation {
  location_type: HorecaLocationType;
  location_number: number;
}

export interface IReserveOrderData {
  cart: ICartItem[],
  service_fee?: number,
  total_cost?: number,
}

export interface IOrderParams {
  notes?: string,
  address?: string,
  city?: string,
  region?: string,
  date?: string,
  time?: Date,
  cash?: boolean,
  card?: boolean,
  persons_count?: string,
  phone_number: string,
  totalItems?: number,
  company_id: number,
  company_name: string,
  company_logo: string,
  company_contacts?: string[],
  location_type?: HorecaLocationType,
  location_number?: number,
}

export enum CurrentOrdersContentTypes {
  LIST = 'list',
  ITEM = 'item'
}

export enum CompanyOrdersNavs {
  CONSOLE = 'console',
  SUCCEEDED = 'succeeded',
  REJECTED = 'rejected',
  CANCELED = 'canceled'
}

export interface ICurrentOrdersHeaderNavs {
  id: CompanyOrdersNavs,
  title: string,
  count: number
}

export enum ExpirationTypes {
  DEMO = 'demo',
  PAID = 'paid'
}

export enum HorecaLocationType {
  TABLE = 'table',
  COUNTER = 'counter',
  ROOM = 'room',
  SUITE = 'suite',
  POOL_CHAIR = 'pool_chair',
  CABANA = 'cabana',
  LOUNGE = 'lounge',
  ZONE = 'zone'
}

export enum DineInQrStatus {
  PENDING = 'pending',
  PARTIAL = 'partial',
  GENERATED = 'generated',
}